<div [formGroup]="complementosGroup">
  <div class="row pt-2 pb-1 pr-2">
    <!-- Tags -->
    @if (mostrarTags && tagsControl) {
      <div class="col-12 mb-3">
        <app-select-pesquisavel
          label="Tags"
          [offlineList]="listaTag"
          [control]="tagsControl"
          idField="idTagContasReceber"
          nameField="descricao"
          corField="cor"
          [multiple]="true"
          [showBadges]="true"
          placeholder="Selecione...">
        </app-select-pesquisavel>
      </div>
    }

    <!-- Observações Html -->
    <div class="col-12">
      <mat-form-field appearance="outline" class="w-100 mb-2">
        <mat-label>Observações do Documento</mat-label>
        <textarea
          matInput
          formControlName="observacao"
          rows="3"
          placeholder="Insira quaisquer anotações relevantes"></textarea>
        @if (isObrigatorio('observacoes_html')) {
          <mat-hint>Obrigatório</mat-hint>
        }
        @if (complementosGroup.get('observacao')?.hasError('required')) {
          <mat-error> Observações é obrigatório </mat-error>
        }
      </mat-form-field>
    </div>

    <!-- NSU / TID -->
    <div class="col-12 col-md-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>NSU / TID</mat-label>
        <input matInput formControlName="nsuTid" placeholder="Insira..." />
        @if (isObrigatorio('nsu_tid')) {
          <mat-hint>Obrigatório</mat-hint>
        }
        @if (complementosGroup.get('nsuTid')?.hasError('required')) {
          <mat-error> NSU / TID é obrigatório </mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Drag zone -->
    @if (!isSomenteLeitura) {
    <div
      class="upload-container"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)">
      <input type="file" #fileInput multiple (change)="onFileSelected($event)" style="display: none" />

      <div class="upload-dropzone" (click)="fileInput.click()">
        <mat-icon class="upload-icon">cloud_upload</mat-icon>
        <p class="upload-text"><strong>Clique para enviar</strong> ou arraste e solte</p>
        <p class="upload-hint">Limitado a 2mb por arquivo (Máximo 10MB Total)</p>
      </div>
    </div>
    }

    <!-- Lista de Arquivos -->
    @if (anexos.length > 0) {
      <div class="file-list mt-3">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <p class="mb-0 font-weight-bold">Arquivos Selecionados:</p>
          @if (!isSomenteLeitura) {
          <button type="button" mat-button (click)="limparAnexos()">
            <mat-icon>delete_sweep</mat-icon> Limpar Todos
          </button>
          }
        </div>
        @for (file of anexos; track file; let i = $index) {
          <div class="file-item">
            <div class="file-info">
              <mat-icon class="file-icon">description</mat-icon>
              <div class="file-details">
                <span class="file-name">{{ file.nomeArquivo }}</span>
                <span class="file-size">{{ formatBytes(file.tamanhoBytes) }}</span>
              </div>
            </div>
            <div>
              @if (file.urlArquivo) {
                <button
                  mat-icon-button
                  type="button"
                  (click)="downloadAnexo(i)"
                  matTooltip="Download arquivo"
                  class="close-icon">
                  <mat-icon>download</mat-icon>
                </button>
              }
              @if (!isSomenteLeitura) {
              <button
                mat-icon-button
                type="button"
                (click)="removeAnexo(i)"
                matTooltip="Remover arquivo"
                class="close-icon">
                <mat-icon>close</mat-icon>
              </button>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
